import { CustomerData } from '@/actions/userActions'
export function setUserPreference(authToken: string) {
  window.localStorage.setItem('auth_token', authToken)
}

export function getUserPreference() {
  return {
    authToken: window.localStorage.getItem('auth_token')
  }
}

export function getUserManagedCustomers(): CustomerData[] {
  const customers = window.localStorage.getItem('customer_info')
  if (!customers) return []

  const parsed = JSON.parse(customers)
  return Array.isArray(parsed) ? parsed : []
}

export function parseJwt(token: string) {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .toString()
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )

  return JSON.parse(jsonPayload)
}
